module.exports = __webpack_public_path__ + "img/2U.ce917f61.jpg";